import { get, writable } from 'svelte/store';
import { persisted as localWriteable } from 'svelte-local-storage-store';
import ByBit from './bybit';
function createSymbols() {
    const { subscribe, set, update } = writable([]);
    const symbols = localWriteable('symbols', []);
    set(get(symbols));
    const getSymbolsFromApi = async () => {
        console.log('getting symbols from api');
        ByBit.GetSymbols()
            .then((symbolData) => {
            console.log('got result', symbolData);
            if (symbolData.length > 0) {
                set(symbolData);
                symbols.set(symbolData);
            }
        })
            .catch((err) => {
            console.log('got error');
            console.error(err);
        });
    };
    getSymbolsFromApi();
    return {
        subscribe,
        set,
        update,
    };
}
export const symbols = createSymbols();
